import {digitUppercase} from './static'
import {t} from '../lang/i18n'
export default {
  install(Vue) {
    // 金额格式化
    Vue.filter('money', function (s) {
      if(s==''||isNaN(s)) return '0.00';
      s=Number(s).toFixed(2).toString();
      s=s.replace(/^(\d*)$/,"$1.");  
      s=(s+"00").replace(/(\d*\.\d\d)\d*/,"$1");  
      s=s.replace(".",",");  
      let re=/(\d)(\d{3},)/;  
      while(re.test(s)){  
        s=s.replace(re,"$1,$2");  
      }  
      s=s.replace(/,(\d\d)$/,".$1");  
      return s.replace(/^\./,"0.");
    });
    // 大写金额
    Vue.filter('upmoney',function(s){
      return digitUppercase(s)
    });
    // 手机号隐藏
    Vue.filter('phonehide', function (s) {
      if(!s) return '';
      return s.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    });
    // 姓名隐藏
    Vue.filter('name', function(s){
      if(!s) return '';
      return s.replace(/(.).+/,'$1**');
    });
    //金额万元显示
    Vue.filter('cn', function(s){
      if(s<10000){
        return s + t('label.w5')
      }
      if(s>=10000){
        let str = s.toString()
        let s1 = parseInt(s/10000) + t('other.w120')
        let s2 = str.substr(str.length-4).replace(/^0+/,'')  + t('label.w5')
        return s1 + s2
      }
    })
  }
}